<template>
  <Modal
    :show="show"
    hide-default-actions
    width="376px"
    @close="handleClose"
  >
    <template #title>
      <h5>Revert to Default Content</h5>
    </template>
    <template #content>
      <p class="text-textLight text-body-3">
        Reverting to the default content for this field will remove any custom content that you have entered.
      </p>
      <p class="text-textLight text-body-3 mb-4">
        <strong>You will not be able to recover custom content without re-typing it.</strong>
      </p>
      <div class="info-section">
        <div class="info-header">
          <span class="info-label text-body-2">Default Content for {{ fieldName }}</span>
        </div>
        <div class="info-value">
          <p class="text-body-3">
            {{ defaultValue }}
          </p>
        </div>
      </div>
      <div class="action-section">
        <DpplNewButton
          class="w-100"
          color="primary"
          variant="flat"
          size="small"
          :class="{ 'revert-modal-btn-loading': loading }"
          :disabled="loading"
          @click="handleConfirm"
        >
          {{ buttonText }}
        </DpplNewButton>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  fieldName: { type: String, default: '' },
  defaultValue: { type: String, default: '' },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'confirm']);

const buttonText = computed(() => (
  props.loading ? 'Reverting to Default Content...' : 'Revert to Default Content'
));

const handleClose = () => {
  emit('close');
};

const handleConfirm = () => {
  emit('confirm');
};
</script>

<style scoped lang="less">
.info-section {
  display: flex;
  flex-direction: column;
  width: 325px;
  margin-bottom: 16px;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.info-label {
  color: @text-darkest;
}

.info-value {
  color: @text-light;
  min-height: 50px;
}

.action-section {
  border-top: 1px solid @stroke-default;
  padding: 16px 24px 0px 24px;
  margin-top: 24px;
  width: calc(100% + 48px);
  transform: translateX(-24px);
}

.revert-modal-btn-loading {
  opacity: 0.4;
}
</style>
